const STORAGE_KEY = "icons";

export function addIconToLocalStorage(icon) {
    if(!icon || !icon.uri || !icon.base64String) return;

    const iconKey = `${icon.workspaceId}_${icon.uri}`;
    let icons = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

    if(!icons.find(iconItem => iconItem.key === iconKey)) {
        icons.push({ key: iconKey, value: icon.base64String });
        localStorage.setItem(STORAGE_KEY, JSON.stringify(icons));
    }
}

export function getIconFromLocalStorage(iconUri, workspaceId) {
    if(!iconUri || !workspaceId) return null;

    const savedIcons = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    const iconKeySpecificWorkspace = `${workspaceId}_${iconUri}`;
    const iconKeyGlobalWorkspace = `0_${iconUri}`;

    let iconItem = savedIcons.find(iconItem => iconItem.key === iconKeySpecificWorkspace);

    if(!iconItem) {
        // Try to find the icon in the global workspace (workspaceId = 0)
        iconItem = savedIcons.find(iconItem => iconItem.key === iconKeyGlobalWorkspace);
    }

    if(iconItem) {
        return iconItem.value;
    }

    return null;
}